<template>
  <div
    :class="['rounded-[10px] bg-[#F6EDFF]', compact ? 'p-2' : 'p-3']"
    data-testid="pinning-image-approval"
  >
    <p class="m-0 text-[10px] font-bold uppercase tracking-wide text-[#9225FF]">AI Preview Ready</p>
    <p :class="['m-0 mt-1 font-semibold text-gray-900', compact ? 'text-xs' : 'text-sm']">
      Does this look right?
    </p>
    <p :class="['m-0 mt-0.5 text-gray-900', compact ? 'text-xs' : 'text-sm']">
      Toggle the image above to compare.
    </p>
    <div :class="['flex gap-2', compact ? 'mt-2' : 'mt-3']">
      <button
        type="button"
        :class="[
          'rounded-lg border border-gray-300 bg-white px-3.5 py-2 text-xs font-medium text-gray-900 [font-family:inherit] hover:bg-gray-50 disabled:pointer-events-none disabled:opacity-25',
          compact ? 'flex-1' : ''
        ]"
        :disabled="disabled"
        data-testid="pinning-reject-image"
        @click="$emit('reject')"
      >
        {{ isRejecting ? "Sending\u2026" : "No, send to Human Artist" }}
      </button>
      <button
        type="button"
        :class="[
          'flex items-center justify-center gap-1 rounded-lg border border-[#00834F] bg-[#00834F] px-3.5 py-2 text-xs font-medium !text-white [font-family:inherit] hover:bg-[#006B40] disabled:pointer-events-none disabled:opacity-25',
          compact ? 'flex-1' : ''
        ]"
        :disabled="disabled"
        data-testid="pinning-approve-image"
        @click="$emit('approve')"
      >
        <CheckIcon class="h-4 w-4" />
        {{ isApproving && !isRejecting ? "Saving\u2026" : "Yes, Save" }}
      </button>
    </div>
  </div>
</template>

<script setup>
import CheckIcon from "assets/icons/check.svg?vue";

defineOptions({ name: "PinApprovalCard" });

defineProps({
  isApproving: { type: Boolean, default: false },
  isRejecting: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  compact: { type: Boolean, default: false }
});

defineEmits(["approve", "reject"]);
</script>
